
import {
    Bed,
    Calendar,
    Plane,
    FileText,
    FerrisWheel,
    CarTaxiFront,
    MicVocal,
    ClockArrowDown,
    CupSoda
} from "lucide-react";
import AccommodationModal from "../modals/AccommodationModal";
import { ModalProps } from "./activities-modal.model";
import ActivityModal from "../modals/ActivityModal";
import FlightModal from "../modals/FlightModal";
import TransportationModal from "../modals/TransportationModal";
import FoodDrinksModal from "../modals/FoodDrinksModal";
import EventsModal from "../modals/EventsModal";
import NotesModal from "../modals/NotesModal";
import { ComponentProps, ReactNode } from "react";

// Activity types
export type ActivityType =
    | 'accommodation'
    | 'activity'
    | 'flight'
    | 'transportation'
    | 'food-drinks'
    | 'events'
    | 'notes';

export interface ActivityTypeConfig {
    id: ActivityType;
    labelKey: string; // Translation key instead of hardcoded label
    icon: ReactNode;
    modal: (commonProps: ModalProps) => ReactNode;
    color: string;
    hidden?: boolean;
}

export const ACTIVITIES: ActivityTypeConfig[] = [
    {
        id: 'accommodation',
        labelKey: 'builder.activities.accommodation',
        icon: <Bed className="h-4 w-4" />,
        // AccommodationModal dichiara le proprie props (onSave tipizzato su AccommodationActivity,
        // non su ItineraryActivity): l'union generica ModalProps non vi si assegna direttamente.
        modal: (commonProps: ModalProps) => (
            <AccommodationModal {...(commonProps as unknown as ComponentProps<typeof AccommodationModal>)} />
        ),
        color: 'bg-blue-100 text-blue-800'
    },
    {
        id: 'accommodationOut',
        labelKey: 'builder.activities.accommodationOut',
        hidden: true,
        icon: <ClockArrowDown className="h-4 w-4" />,
        // AccommodationModal dichiara le proprie props (onSave tipizzato su AccommodationActivity,
        // non su ItineraryActivity): l'union generica ModalProps non vi si assegna direttamente.
        modal: (commonProps: ModalProps) => (
            <AccommodationModal {...(commonProps as unknown as ComponentProps<typeof AccommodationModal>)} />
        ),
        color: 'bg-blue-100 text-blue-800'
    },
    {
        id: 'activity',
        labelKey: 'builder.activities.activity',
        icon: <FerrisWheel className="h-4 w-4" />,
        modal: (commonProps: ModalProps) => <ActivityModal {...commonProps} />,
        color: 'bg-green-100 text-green-800'
    },
    {
        id: 'flight',
        labelKey: 'builder.activities.flight',
        icon: <Plane className="h-4 w-4" />,
        modal: (commonProps: ModalProps) => <FlightModal {...commonProps} />,
        color: 'bg-sky-100 text-sky-800'
    },
    {
        id: 'transportation',
        labelKey: 'builder.activities.transportation',
        icon: <CarTaxiFront className="h-4 w-4" />,
        modal: (commonProps: ModalProps) => <TransportationModal {...commonProps} />,
        color: 'bg-orange-100 text-orange-800'
    },
    {
        id: 'food-drinks',
        labelKey: 'builder.activities.foodDrinks',
        icon: <CupSoda className="h-4 w-4" />,
        modal: (commonProps: ModalProps) => <FoodDrinksModal {...commonProps} />,
        color: 'bg-amber-100 text-amber-800'
    },
    {
        id: 'events',
        labelKey: 'builder.activities.events',
        icon: <MicVocal className="h-4 w-4" />,
        modal: (commonProps: ModalProps) => <EventsModal {...commonProps} />,
        color: 'bg-purple-100 text-purple-800'
    },
    {
        id: 'notes',
        labelKey: 'builder.activities.notes',
        icon: <FileText className="h-4 w-4" />,
        modal: (commonProps: ModalProps) => <NotesModal {...commonProps} />,
        color: 'bg-gray-100 text-gray-800'
    }
];

export const getActivityTypeConfig = (type: ActivityType): ActivityTypeConfig | undefined => {
    return ACTIVITIES.find(config => config.id === type);
};

export const getActivityTypeIcon = (type: ActivityType): React.ReactNode => {
    const config = getActivityTypeConfig(type);
    return config?.icon || <Calendar className="h-4 w-4" />;
};

export const getActivityTypeColor = (type: ActivityType): string => {
    const config = getActivityTypeConfig(type);
    return config?.color || 'bg-gray-100 text-gray-800';
};

export const getActivityTypeLabel = (type: ActivityType): string => {
    const config = getActivityTypeConfig(type);
    return config?.labelKey || 'builder.activities.activity';
};

export const getActivityModal = (type: ActivityType) => {
    const config = getActivityTypeConfig(type);
    return config.modal || (() => console.error('no modal'))
}